import { render, staticRenderFns } from "./DealProfitGrid.vue?vue&type=template&id=1de25d22&"
import script from "./DealProfitGrid.vue?vue&type=script&lang=js&"
export * from "./DealProfitGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports